module.exports = __webpack_public_path__ + "static/media/patrol(12).0f1b4362.PNG";